var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('post-layout',[_c('h1',[_vm._v(_vm._s(_vm.research[_vm.$i18n.locale][0].title))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.research[_vm.$i18n.locale][0].detail)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }